import { token } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  background-color: ${token('colors.gray100')};
`;
